import { useMutation } from "@tanstack/react-query";

import { cardsAPI } from "../cardsAPI.ts";
import { addNewPaymentMethodMutation } from "../helpers";

export const useAddSbpMutation = () => {
  return useMutation ({
    mutationKey: ["add-sbp"],
    mutationFn: ({ signal }: { signal: AbortSignal }) => {
      return addNewPaymentMethodMutation({ addMethod: cardsAPI.addSbp, signal });
    },
  });
};
